import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { isLyrraOne } from '@/lib/platform';
import { useLyrraOnePlan } from '@/hooks/useLyrraOnePlan';
import {
  LYRRAONE_SUBSCRIPTION_PATH,
  minTierLabelForFeature,
  type LyrraOnePlanFeature,
} from '@/lib/lyrraone-plan';

type LyrraOnePlanGatedActionProps = {
  feature: LyrraOnePlanFeature;
  children: React.ReactNode;
  className?: string;
};

/** Affiche l’action enfant si le plan l’inclut, sinon un lien vers l’abonnement. */
export function LyrraOnePlanGatedAction({
  feature,
  children,
  className,
}: LyrraOnePlanGatedActionProps) {
  const { hasFeature, loading } = useLyrraOnePlan();

  if (!isLyrraOne() || loading || hasFeature(feature)) {
    return <>{children}</>;
  }

  const minPlan = minTierLabelForFeature(feature);

  return (
    <Link
      to={LYRRAONE_SUBSCRIPTION_PATH}
      className={
        className
        ?? 'inline-flex items-center gap-1.5 rounded-lg border border-dashed px-3 py-1.5 text-sm text-gray-600 hover:border-[color:var(--lo-blue)] hover:text-[color:var(--lo-blue)] dark:text-gray-300'
      }
      title={`Disponible à partir du plan ${minPlan}`}
    >
      <Lock className="h-4 w-4 shrink-0" aria-hidden />
      <span>Plan {minPlan}</span>
    </Link>
  );
}
